/* 17/10/2026 : FastClick (app.js, timber.init) bloquait le 1er tap sur iOS. Inutile depuis iOS 9.3 : neutralisé avant $(timber.init). */
if (window.FastClick) { window.FastClick.attach = function () { return {}; }; }
/* INMG Cart Drawer v2.4 - 17/10/2026 (sous-titre produit sous le nom court). Vanilla JS, Shadow DOM. */
(function () {
  'use strict';
  if (window.INMGCart) return;
  var cfgEl = document.getElementById('inmg-cd-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!CFG.enabled) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var state = { cart: null, products: {}, open: false, busy: false, internal: 0 };

  /* ---------- helpers ---------- */
  function money(cents) {
    var n = (Math.round(cents) / 100).toFixed(2).split('.');
    n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return n[0] + ',' + n[1] + ' €';
  }
  function shortTitle(t) { t = String(t || ''); var i = t.indexOf('™'); return i > -1 && t.slice(i + 1).trim().charAt(0) !== '+' ? t.slice(0, i + 1) : t; }
  /* sous-titre = ce qui suit le ™ dans le titre Shopify (ex. "Caméra intérieure rotative"), en minuscules sauf sigles */
  function subTitle(t) {
    t = String(t || ''); var i = t.indexOf('™'); if (i < 0) return '';
    var r = t.slice(i + 1).trim(); if (!r || r.charAt(0) === '+') return '';
    return r.split(/\s+/).map(function (w, k) {
      if (/^wifi$/i.test(w)) return 'WiFi';
      return k && /^[A-ZÀ-Ý][a-zà-ÿ]+$/.test(w) ? w.toLowerCase() : w;
    }).join(' ');
  }
  function subHtml(t) { var s = subTitle(t); return s ? '<span class="sub">' + esc(s) + '</span>' : ''; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(url, w) { if (!url) return ''; if (url.indexOf('//') === 0) url = 'https:' + url; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function api(path, opts) {
    state.internal++;
    return fetch(ROOT + path.replace(/^\//, ''), opts).then(function (r) {
      state.internal--;
      if (!r.ok) return r.json().then(function (j) { throw j; }, function () { throw { description: 'Erreur ' + r.status }; });
      return r.json();
    }, function (e) { state.internal--; throw e; });
  }
  function post(path, body) {
    return api(path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }
  function product(handle) {
    if (state.products[handle]) return Promise.resolve(state.products[handle]);
    return api('products/' + handle + '.js').then(function (p) { state.products[handle] = p; return p; }).catch(function () { return null; });
  }

  function bannerHtml(b) { var p = String(b).split(' · '); return p.length > 1 ? '<strong>' + esc(p[0]) + '</strong> · ' + esc(p.slice(1).join(' · ')) : esc(b); }

  /* ---------- DOM ---------- */
  var host = document.createElement('div');
  host.id = 'inmg-cart-drawer';
  host.className = 'needsclick';
  host.style.cssText = 'position:relative;z-index:2147483000;visibility:hidden';
  var shadow = host.attachShadow({ mode: 'open' });
  shadow.innerHTML =
    '<style>.drawer{transform:translateX(100%)}.overlay{opacity:0;visibility:hidden}</style>' +
    '<link rel="stylesheet" href="' + esc(CFG.css) + '">' +
    '<div class="overlay" part="overlay"></div>' +
    '<aside class="drawer" role="dialog" aria-modal="true" aria-label="Votre panier" tabindex="-1">' +
      '<div class="head"><h2>Votre panier<span class="count"></span></h2>' +
      '<button class="close" type="button" aria-label="Fermer le panier"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M3 3l10 10M13 3L3 13"/></svg></button></div>' +
      '<div class="body">' + (CFG.banner ? '<div class="banner">' + bannerHtml(CFG.banner) + '</div>' : '') + '<div class="items"></div><div class="ups" hidden></div><div class="trust" hidden></div></div>' +
      '<div class="foot" hidden></div>' +
      '<div class="sr" aria-live="polite"></div>' +
    '</aside>';
  var $ = function (s) { return shadow.querySelector(s); };
  (function () { var l = shadow.querySelector('link'), show = function () { host.style.visibility = ''; };
    if (l) { l.addEventListener('load', show); l.addEventListener('error', show); } setTimeout(show, 3000); })();
  var payIcons = (document.getElementById('inmg-cd-payicons') || {}).innerHTML || '';

  function mount() { if (!host.isConnected) document.body.appendChild(host); }

  /* ---------- open / close ---------- */
  var lastFocus = null;
  function open() {
    mount();
    if (state.open) return;
    state.open = true; lastFocus = document.activeElement;
    host.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    setTimeout(function () { var c = $('.close'); if (c) c.focus({ preventScroll: true }); }, 50);
    document.dispatchEvent(new CustomEvent('inmg:cart:open'));
  }
  function close() {
    if (!state.open) return;
    state.open = false;
    host.classList.remove('open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }

  /* ---------- render ---------- */
  function renderItems(cart) {
    var box = $('.items');
    $('.count').textContent = cart.item_count ? ' (' + cart.item_count + ')' : '';
    if (!cart.item_count) {
      var eo = CFG.emptyOffer, ep = eo && state.products[eo.handle];
      var ev = ep && (ep.variants.filter(function (v) { return v.id === +eo.variant && v.available; })[0] || ep.variants.filter(function (v) { return v.available; })[0]);
      box.innerHTML = '<div class="empty"><p>Votre panier est vide.</p>' +
        (ev ? '<div class="best"><div class="bl">Notre best-seller</div><div class="card"><a href="' + esc(ep.url) + '"><img src="' + esc(img((ev.featured_image && ev.featured_image.src) || ep.featured_image, 160)) + '" alt="" loading="lazy"></a>' +
          '<div><a class="t" href="' + esc(ep.url) + '">' + esc(shortTitle(ep.title)) + '</a>' + subHtml(ep.title) + '<div class="p">' + priceHtml(ev) + '</div></div>' +
          '<button class="add" type="button" data-act="up" data-variant="' + ev.id + '" data-qty="1" data-src="drawer_empty">Ajouter</button></div></div>' : '') +
        '<a class="all" href="' + ROOT + 'collections/camera-de-surveillance-connectee-wifi">Voir toutes nos caméras</a></div>';
      return;
    }
    box.innerHTML = cart.items.map(function (it, i) {
      var p = state.products[it.handle];
      var v = p && p.variants.filter(function (x) { return x.id === it.variant_id; })[0];
      var compare = v && v.compare_at_price > it.original_price ? v.compare_at_price * it.quantity : 0;
      var paid = it.final_line_price;
      var save = compare ? compare - paid : (it.original_line_price - paid);
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="chip">' + esc(it.variant_title) + '</span>' : '';
      return '<div class="item" data-key="' + esc(it.key) + '">' +
        '<a href="' + esc(it.url) + '"><img src="' + esc(img(it.image, 160)) + '" alt="" loading="lazy"></a>' +
        '<div><a class="title" href="' + esc(it.url) + '">' + esc(shortTitle(it.product_title)) + '</a>' + subHtml(it.product_title) + variant +
          '<div class="row"><div class="qty"><button type="button" data-act="dec" aria-label="Diminuer">−</button><span>' + it.quantity + '</span><button type="button" data-act="inc" aria-label="Augmenter">+</button></div>' +
          '<div class="price"><b>' + money(paid) + '</b>' + (compare ? '<s>' + money(compare) + '</s>' : '') +
          (save > 0 ? '<div class="save">Économisez ' + money(save) + '</div>' : '') + '</div></div></div>' + packHint(it, p) +
        '<button class="del" type="button" data-act="del" aria-label="Retirer ' + esc(shortTitle(it.product_title)) + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"/></svg></button>' +
      '</div>';
    }).join('');
  }

  /* Upsell rules (mirror of the OCU funnels). A rule fires when the cart holds one of its
     trigger products; matchQty = offer quantity equals the number of cameras of those triggers
     (pack x2 = 2). Offers already in the cart are hidden; same product from 2 rules is merged. */

  /* Suggestion pack (17/10/2026) : variante x1 en quantité >= 2 alors qu'un pack de la même taille coûte moins cher. */
  function packFor(it, p) {
    if (!p || packSize(it) !== 1 || it.quantity < 2) return null;
    var pv = p.variants.filter(function (v) { return v.available && packSize({ variant_title: v.title }) === it.quantity; })[0];
    if (!pv) return null;
    var gain = it.original_price * it.quantity - pv.price;
    return gain > 0 ? { variant: pv, gain: gain } : null;
  }
  function packHint(it, p) {
    var k = packFor(it, p);
    if (!k) return '';
    return '<div class="pack"><div class="pt">Pack x' + it.quantity + ' à <b>' + money(k.variant.price) + '</b>' +
      '<span><b>' + money(k.gain) + '</b> de moins</span></div>' +
      '<button class="swap" type="button" data-act="pack" data-variant="' + k.variant.id + '">Passer au pack</button></div>';
  }
  function packSize(it) { var m = /(?:^|\W)x\s?(\d+)/i.exec(it.variant_title || ''); return m ? +m[1] : 1; }
  function computeOffers(cart) {
    /* qtyIn = units of each product already in the cart (any variant).
       "one per camera" offers: needed = cameras of ALL matching rules summed (Solar Dome x2 + Mini x1 = 3 cards),
       shown only for the missing quantity (4 cameras + 1 card already = offer 3). Other offers: hidden once in cart. */
    var qtyIn = {}, out = [], byHandle = {}, fired = false;
    cart.items.forEach(function (it) { qtyIn[it.handle] = (qtyIn[it.handle] || 0) + it.quantity; });
    (CFG.rules || []).forEach(function (r) {
      var units = 0;
      cart.items.forEach(function (it) { if ((r.triggers || []).indexOf(it.handle) > -1) units += it.quantity * packSize(it); });
      if (!units) return;
      fired = true;
      (r.offers || []).forEach(function (o) {
        if (!o.handle) return;
        var e = byHandle[o.handle];
        if (!e) { e = byHandle[o.handle] = { handle: o.handle, variant: o.variant, need: 0, matchQty: false }; out.push(e); }
        if (r.matchQty) { e.matchQty = true; e.need += units; } else e.need = Math.max(e.need, 1);
      });
    });
    /* fallback only when no rule fired and no "camera + card" bundle is in the cart */
    var hasBundle = cart.items.some(function (it) { return /carte|micro-sd/i.test(it.handle) && it.handle !== 'carte-microsd'; });
    if (!fired && !hasBundle && cart.item_count) (CFG.fallback || []).forEach(function (o) {
      if (o.handle && !byHandle[o.handle]) { byHandle[o.handle] = { handle: o.handle, variant: o.variant, need: 1, matchQty: false }; out.push(byHandle[o.handle]); }
    });
    out.forEach(function (o) {
      var have = qtyIn[o.handle] || 0;
      o.have = have;
      o.qty = o.matchQty ? o.need - have : (have ? 0 : 1);
    });
    return out.filter(function (o) { var p = state.products[o.handle]; return o.qty > 0 && p && p.available; }).slice(0, CFG.maxOffers || 3);
  }
  function offerHandles() {
    var h = [];
    (CFG.rules || []).forEach(function (r) { (r.offers || []).forEach(function (o) { h.push(o.handle); }); });
    (CFG.fallback || []).forEach(function (o) { h.push(o.handle); });
    if (CFG.emptyOffer) h.push(CFG.emptyOffer.handle);
    return h;
  }

  function renderUpsells(cart) {
    var box = $('.ups');
    var list = computeOffers(cart);
    if (!cart.item_count || !list.length) { box.hidden = true; box.innerHTML = ''; return; }
    box.hidden = false;
    box.innerHTML = '<h3>' + esc(CFG.upsellTitle || 'Vous aimerez aussi') + '</h3>' + list.map(function (u) {
      var p = state.products[u.handle];
      var vars = p.variants.filter(function (v) { return v.available; });
      var def = vars.filter(function (v) { return v.id === +u.variant; })[0] || vars[0];
      var sel = vars.length > 1 ? '<select data-handle="' + esc(p.handle) + '" aria-label="Choisir une option">' + vars.map(function (v) {
        return '<option value="' + v.id + '"' + (v.id === def.id ? ' selected' : '') + '>' + esc(v.title) + '</option>';
      }).join('') + '</select>' : '';
      var qtyTxt = u.matchQty && u.have ? '<div class="q">Il en manque ' + u.qty + ' (une par caméra)</div>'
        : (u.qty > 1 ? '<div class="q">x' + u.qty + ' (une par caméra)</div>' : '');
      return '<div class="card" data-handle="' + esc(p.handle) + '"><img src="' + esc(img((def.featured_image && def.featured_image.src) || p.featured_image, 120)) + '" alt="" loading="lazy">' +
        '<div><div class="t">' + esc(shortTitle(p.title)) + '</div>' + subHtml(p.title) + '<div class="p">' + priceHtml(def) + '</div>' + qtyTxt + '</div>' +
        '<button class="add" type="button" data-act="up" data-variant="' + def.id + '" data-qty="' + u.qty + '">' + (u.qty > 1 ? 'Ajouter x' + u.qty : 'Ajouter') + '</button>' + sel + '</div>';
    }).join('');
  }
  function priceHtml(v) {
    if (v.compare_at_price && v.compare_at_price > v.price) {
      return '<span class="now red">' + money(v.price) + '</span><s>' + money(v.compare_at_price) + '</s><span class="off">Économisez ' + money(v.compare_at_price - v.price) + '</span>';
    }
    return '<span class="now">' + money(v.price) + '</span>';
  }

  /* visitor country: Shopify geo-IP suggestion (like OCU), cached per session; fallback = market country */
  var visitorCountry = null;
  function detectCountry() {
    try { visitorCountry = sessionStorage.getItem('inmg_cc'); } catch (e) {}
    if (visitorCountry) return Promise.resolve(visitorCountry);
    state.internal++;
    return fetch(ROOT + 'browsing_context_suggestions.json?country[enabled]=true').then(function (r) { return r.json(); })
      .then(function (j) { visitorCountry = (j && j.detected_values && j.detected_values.country && j.detected_values.country.handle) || ''; })
      .catch(function () { visitorCountry = ''; })
      .then(function () {
        state.internal--;
        if (!visitorCountry) visitorCountry = (window.Shopify && Shopify.country) || 'FR';
        try { sessionStorage.setItem('inmg_cc', visitorCountry); } catch (e) {}
        return visitorCountry;
      });
  }
  var TAG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>';
  var LOCK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';

  var STAR = '<svg width="15" height="15" viewBox="0 0 24 24" fill="#f5a623"><path d="M12 2l3.1 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.8 21l1.2-6.8-5-4.9 6.9-1z"/></svg>';
  var SHIELD = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>';
  var BACK = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>';
  var TRUCK = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 3h15v13H1zM16 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
  function renderTrust(cart) {
    var box = $('.trust'), b = (CFG.badges || []).filter(function (x) { return x && x.trim(); }).slice(0, 3);
    if (!cart.item_count || !b.length) { box.hidden = true; box.innerHTML = ''; return; }
    var ic = [STAR, SHIELD, BACK];
    box.hidden = false;
    box.innerHTML = b.map(function (t, i) { return '<div class="tb">' + ic[i] + '<span>' + esc(t.trim()) + '</span></div>'; }).join('');
  }
  function totalSavings(cart) {
    var ref = 0;
    cart.items.forEach(function (it) {
      var p = state.products[it.handle];
      var v = p && p.variants.filter(function (x) { return x.id === it.variant_id; })[0];
      var unit = v && v.compare_at_price > it.original_price ? v.compare_at_price : it.original_price;
      ref += unit * it.quantity;
    });
    return ref - cart.total_price;
  }

  function renderFoot(cart) {
    var f = $('.foot');
    if (!cart.item_count) { f.hidden = true; f.innerHTML = ''; return; }
    f.hidden = false;
    /* discount codes: cart-level + line-level, merged by title */
    var codes = {}, order = [];
    (cart.cart_level_discount_applications || []).forEach(function (d) { if (!d.title || !(d.total_allocated_amount > 0)) return; if (!codes[d.title]) { codes[d.title] = 0; order.push(d.title); } codes[d.title] += d.total_allocated_amount; });
    cart.items.forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) {
      var t = a.discount_application && a.discount_application.title; if (!t || a.discount_application.type === 'automatic' || !(a.amount > 0)) return;
      if (!codes[t]) { codes[t] = 0; order.push(t); } codes[t] += a.amount; }); });
    var rows = order.map(function (t) {
      return '<div class="ln"><span>Code promo <span class="cd">' + esc(t) + '</span><button class="rm" type="button" data-act="rmcode" data-code="' + esc(t) + '" aria-label="Retirer le code ' + esc(t) + '">×</button></span><span class="g">-' + money(codes[t]) + '</span></div>';
    }).join('');
    var fs = CFG.freeShipping || {}, cc = visitorCountry || (window.Shopify && Shopify.country) || 'FR', isFR = !fs.country || cc === fs.country;
    var shipVal = '', hint = '';
    if (!isFR) shipVal = esc(CFG.shippingIntl || 'Calculée à l\'étape suivante');
    else if (fs.threshold > 0) {
      var left = fs.threshold - cart.total_price;
      if (left <= 0) shipVal = 'Gratuite';
      else { shipVal = money(CFG.shippingFR || 399); hint = '<div class="hint">Plus que ' + money(left) + ' pour la livraison gratuite</div>'; }
    }
    rows += '<div class="ln"><span>Livraison à domicile</span><span>' + shipVal + '</span></div>' + hint;
    var sv = CFG.showSavings !== false ? totalSavings(cart) : 0;
    if (sv > 0) rows += '<div class="ln"><span>Vos économies</span><span class="g">' + money(sv) + '</span></div>';
    rows += '<div class="ln tot"><span>Sous-total</span><span>' + money(cart.total_price) + '</span></div>';
    f.innerHTML = '<div class="sum">' + rows + '</div>' +
      '<button class="cta" type="button" data-act="checkout">' + LOCK + esc(CFG.checkoutLabel || 'Commander') + '</button>' +
      (payIcons ? '<div class="pay">' + payIcons + '</div>' : '') +
      (CFG.reassurance ? '<div class="reassure">' + LOCK + '<span>' + esc(CFG.reassurance) + '</span></div>' : '');
  }

  function syncThemeCount(n) {
    ['#cartItemCount', '.cart-count', '.cart_count', '[data-cart-count]'].forEach(function (s) {
      document.querySelectorAll(s).forEach(function (el) { el.textContent = n; });
    });
  }

  function render() {
    var cart = state.cart; if (!cart) return;
    renderItems(cart); renderUpsells(cart); renderTrust(cart); renderFoot(cart);
    syncThemeCount(cart.item_count);
  }

  function refresh(openAfter) {
    return api('cart.js').then(function (cart) {
      state.cart = cart;
      var handles = cart.items.map(function (i) { return i.handle; }).concat(offerHandles());
      return Promise.all(handles.filter(function (h, i) { return handles.indexOf(h) === i; }).map(product));
    }).then(function () {
      render();
      if (openAfter) open();
      document.dispatchEvent(new CustomEvent('inmg:cart:updated', { detail: state.cart }));
    }).catch(function () { if (openAfter) open(); });
  }

  function setBusy(on) { var d = $('.drawer'); if (d) d.classList.toggle('busy', on); state.busy = on; if (!on) [].forEach.call(shadow.querySelectorAll('.loading'), function (b) { b.classList.remove('loading'); }); }
  function say(msg) { var s = $('.sr'); if (s) { s.textContent = ''; setTimeout(function () { s.textContent = msg; }, 30); } }

  function change(key, qty) {
    setBusy(true);
    /* change.js returns a partial cart (discount titles/amounts missing): always re-read cart.js */
    return post('cart/change.js', { id: key, quantity: qty }).then(function () {
      return refresh(false);
    }).then(function () { say('Panier mis à jour'); }).catch(function (e) { alertMsg(e); return refresh(); }).then(function () { setBusy(false); });
  }
  function swapToPack(key, variantId, btn) {
    setBusy(true);
    return post('cart/add.js', { items: [{ id: +variantId, quantity: 1, properties: { _inmg_source: 'drawer_pack' } }] })
      .then(function () { return post('cart/change.js', { id: key, quantity: 0 }); })
      .then(function () { return refresh(false); })
      .then(function () { say('Pack ajouté à la place des unités'); })
      .catch(function (e) { alertMsg(e); return refresh(); })
      .then(function () { setBusy(false); });
  }
  function removeCode(code, all) {
    setBusy(true);
    var keep = all.filter(function (c) { return c !== code; }).join(',');
    return post('cart/update.js', { discount: keep })
      .then(function () { return refresh(false); })
      .then(function () { say('Code retiré'); })
      .catch(function (e) { alertMsg(e); return refresh(); })
      .then(function () { setBusy(false); });
  }
  function addUpsell(variantId, btn, src) {
    var qty = Math.max(1, +btn.getAttribute('data-qty') || 1), label = btn.textContent;
    btn.disabled = true; setBusy(true);
    return post('cart/add.js', { items: [{ id: +variantId, quantity: qty, properties: { _inmg_source: src || 'drawer_upsell' } }] })
      .then(function () { return refresh(false); })
      .then(function () { say('Produit ajouté'); setBusy(false); })
      .catch(function (e) { alertMsg(e); btn.disabled = false; btn.textContent = label; setBusy(false); });
  }
  function alertMsg(e) {
    var m = (e && (e.description || e.message)) || 'Une erreur est survenue, réessayez.';
    say(m);
    var s = $('.items'); if (s) { var d = document.createElement('div'); d.className = 'empty'; d.style.padding = '10px'; d.style.color = '#e11d2e'; d.textContent = m; s.prepend(d); setTimeout(function () { d.remove(); }, 4000); }
  }

  /* ---------- events inside drawer ---------- */
  shadow.addEventListener('click', function (ev) {
    var t = ev.target.closest('button, .overlay');
    if (!t) return;
    if (t.classList.contains('overlay') || t.classList.contains('close')) { close(); return; }
    if (state.busy) return;
    var act = t.getAttribute('data-act');
    if (act && act !== 'checkout') t.classList.add('loading');
    var row = t.closest('.item');
    if (row) {
      var key = row.getAttribute('data-key');
      var it = state.cart.items.filter(function (i) { return i.key === key; })[0];
      if (!it) return;
      if (act === 'inc') change(key, it.quantity + 1);
      if (act === 'dec') change(key, it.quantity - 1);
      if (act === 'del') change(key, 0);
      if (act === 'pack') swapToPack(key, t.getAttribute('data-variant'), t);
    }
    if (act === 'up') addUpsell(t.getAttribute('data-variant'), t, t.getAttribute('data-src'));
    if (act === 'rmcode') { var all = [].slice.call(shadow.querySelectorAll('[data-act="rmcode"]')).map(function (b) { return b.getAttribute('data-code'); }); removeCode(t.getAttribute('data-code'), all); return; }
    if (act === 'checkout') { t.disabled = true; window.location.href = ROOT + 'checkout'; }
  });
  shadow.addEventListener('change', function (ev) {
    var sel = ev.target;
    if (sel.tagName !== 'SELECT') return;
    var card = sel.closest('.card');
    var p = state.products[sel.getAttribute('data-handle')];
    var v = p && p.variants.filter(function (x) { return String(x.id) === sel.value; })[0];
    if (!v) return;
    card.querySelector('.add').setAttribute('data-variant', v.id);
    card.querySelector('.p').innerHTML = priceHtml(v);
    if (v.featured_image && v.featured_image.src) card.querySelector('img').src = img(v.featured_image.src, 120);
  });
  document.addEventListener('keydown', function (ev) {
    if (!state.open) return;
    if (ev.key === 'Escape') { close(); return; }
    if (ev.key === 'Tab') {
      var f = [].slice.call(shadow.querySelectorAll('button:not([disabled]), a[href], select'));
      if (!f.length) return;
      var a = shadow.activeElement;
      if (ev.shiftKey && a === f[0]) { f[f.length - 1].focus(); ev.preventDefault(); }
      else if (!ev.shiftKey && a === f[f.length - 1]) { f[0].focus(); ev.preventDefault(); }
    }
  });

  /* ---------- detect add-to-cart from any source (PageFly, theme, apps) ---------- */
  var ADD_RE = /\/cart\/add(\.js|\.json)?(\?|$)/;
  var CHANGE_RE = /\/cart\/(change|update|clear)(\.js|\.json)?(\?|$)/;
  function onExternal(url) {
    if (ADD_RE.test(url)) setTimeout(function () { refresh(true); }, 60);
    else if (CHANGE_RE.test(url)) setTimeout(function () { refresh(false); }, 60);
  }
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var mine = state.internal > 0;
      var p = _fetch.apply(this, arguments);
      if (!mine && (ADD_RE.test(url) || CHANGE_RE.test(url))) {
        p.then(function (r) { if (r && r.ok) onExternal(url); }, function () {});
      }
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this.__inmgUrl = String(url || ''); return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this, url = x.__inmgUrl || '';
    if (ADD_RE.test(url) || CHANGE_RE.test(url)) {
      x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) onExternal(url); });
    }
    return _send.apply(this, arguments);
  };

  /* header cart icon -> drawer (the /cart page itself keeps working) */
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[href="/cart"], a[href^="/cart?"], a[href="' + ROOT + 'cart"], .header_cart_icon, [data-inmg-open-cart]');
    if (!a || ev.metaKey || ev.ctrlKey || ev.shiftKey) return;
    if (/\/cart\/?$/.test(location.pathname)) return;
    ev.preventDefault(); ev.stopPropagation();
    refresh(true);
  }, true);

  /* public API */
  window.INMGCart = { open: function () { return refresh(true); }, close: close, refresh: refresh };

  function init() { mount(); refresh(false); detectCountry().then(function () { if (state.cart) render(); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
